import React from 'react';
import Colors from '../../utils/colors';

const StatusBadge = ({ status, type = 'status' }) => {
  const getBadgeStyle = (value, badgeType) => {
    let backgroundColor, color;
    
    if (badgeType === 'status') {
      switch (value?.toLowerCase()) {
        case 'active':
          backgroundColor = Colors.successLight;
          color = Colors.success;
          break;
        case 'inactive':
          backgroundColor = Colors.errorLight;
          color = Colors.error;
          break;
        default:
          backgroundColor = Colors.lightGray;
          color = Colors.gray;
      }
    } else if (badgeType === 'role') {
      switch (value?.toLowerCase()) {
        case 'admin':
          backgroundColor = Colors.errorLight;
          color = Colors.error;
          break;
        case 'user':
          backgroundColor = Colors.infoLight;
          color = Colors.info;
          break;
        default:
          backgroundColor = Colors.lightGray;
          color = Colors.gray;
      }
    } else if (badgeType === 'canApprove') {
      switch (value?.toLowerCase()) {
        case 'yes':
          backgroundColor = Colors.successLight;
          color = Colors.success;
          break;
        case 'no':
          backgroundColor = Colors.errorLight;
          color = Colors.error;
          break;
        default:
          backgroundColor = Colors.lightGray;
          color = Colors.gray;
      }
    }
    
    return {
      backgroundColor,
      color,
      padding: '4px 8px',
      borderRadius: '12px',
      fontSize: '11px',
      fontWeight: '500',
      textTransform: 'capitalize',
      display: 'inline-block',
      minWidth: '60px',
      textAlign: 'center'
    };
  };

  return (
    <span style={getBadgeStyle(status, type)}>
      {status}
    </span>
  );
};

export default StatusBadge;